module.exports = __webpack_public_path__ + "static/media/LogoEyeflowEdge.2b6d45f0.png";